module.exports = __webpack_public_path__ + "img/selected5-min.6510e64b.png";